import { render, staticRenderFns } from "./UploadNewButton.vue?vue&type=template&id=b6e0a392&scoped=true&"
import script from "./UploadNewButton.vue?vue&type=script&lang=js&"
export * from "./UploadNewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e0a392",
  null
  
)

export default component.exports